import React from 'react';
import { Card, Image, Spinner, Container } from 'react-bootstrap';
import {  AxiosInstance } from '../../../utils/RequestMethods';

import { Typography, Button, Box, IconButton, Collapse, Grid } from '@mui/material';
import * as _ from 'lodash'

import config from '../../../constants/config';
import images from '../../../constants/images';
import { initObjectPaymentCard, PaymentCardT } from '../../../types/Payments';
import { IAppState } from '../../../redux/reducers';
import { currentUserIsManager } from '../../../utils/currentUser';
import { CreditCard } from '../CreditCard';
import { LineItemTransactionT, TransactionT } from '../../../types/TransactionT';


import { LoadElementsStripe } from '../../FormStripe/LoadElementsStripe';
import LineItemCard from './LineItemCard';
import { findPrimaryCard, parseFloatTotal } from '../../../utils/utilsT';
import ListItemCards from './ListItemCards';
import { ButtonChargeCard } from './ButtonChargeCard';
import FormSaveCard from '../../FormStripe/FormSaveCard'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import FormTipPayment from './FormTipPayment';
import { useImmer } from 'use-immer';
import { copyObject, randomId } from '../../../utils';
import { RevenueLineItemT } from '../../../types/Job';

interface ViewSectionT {
    showFormTip: boolean
    showListCard: boolean
    showFormAddCard: boolean
    showConfirmButton: boolean
}

type KeysViewSectionT = keyof ViewSectionT;
export interface IListCreditCardsCheckoutProps {

    productId: number // example jobId
    productType: string // example jobs
    userId?: number
    onCompleteProcessing(transaction: TransactionT): void
    paymentItems: Array<LineItemTransactionT>
    toggleView?(value: boolean): void
    showAddCard?: boolean
    titleButton?: string
    customButtonProps?: any
    displayFormTip?: boolean
    addLineItemTip?(item: LineItemTransactionT): void
    removeLineItemTip?(): void
    // charge?(card: ItemCard): Promise<void>
}

const PayByCard: React.FC<IListCreditCardsCheckoutProps> = (props) => {

    // let auth = useSelector((state: IAppState) => state.auth)
    // const roles = auth && auth.userData && auth.userData.roles ? auth.userData.roles : []
    const [cards, setCards] = React.useState<Array<PaymentCardT>>([]);
    const [isReady, setIsReady] = React.useState(false);
    const userIsManager = currentUserIsManager()
    const [stripe, setStripe] = React.useState(null);
    const [primaryCard, setPrimaryCard] = React.useState<PaymentCardT | null>(null);
    const [optionTip, setOptionTip] = React.useState("");


    const [stateViewSection, setStateViewSection] = useImmer({
        showFormTip: false,
        showListCard: false,
        showFormAddCard: false,
        showConfirmButton: false,

    });

    const [lineItemTip, setLineItemTip] = React.useState<LineItemTransactionT | null>(null);


    React.useEffect(() => {
        const totalAmount = props.paymentItems.reduce((price, item, index) => {
            return Number(price) + Number(item.amount)
        }, 0)

        console.log("lineItems->ManagePaymentsCards", props.paymentItems)


    }, [props.paymentItems]);
    React.useEffect(() => {
        getCards()

    }, []);


    // if any section it's view it will hidden parent secetion
    React.useEffect(() => {
        const isView = Object.keys(stateViewSection).find((key) => stateViewSection[key] == true)
        if (props.toggleView) {
            props.toggleView(isView ? true : false)
        }
    }, [stateViewSection]);


    const allPaymentItems = React.useMemo(() => {
        let items = []
        props.paymentItems.map((item, index) => {
            if (item.amount > 0) {
                items.push({
                    ...item, ...{
                        amount: Number(item.amount),
                        productRate: Number(item.productRate),
                        productUnits: Number(item.productUnits)
                    }
                })
            }
        })

        if (lineItemTip) {
            items.push(lineItemTip)
        }
        return items
    }, [props.paymentItems, lineItemTip]);


    /**
     * getCards
     */
    const getCards = async (): Promise<void> => {
        let params = {
            all: true,
            order: "desc"
        }

        let userId = userIsManager ? props.userId : null
        let url = `${config.url.payments}/cards`
        if (userId) {
            url = `${url}/${userId}`
        }
        let options={
          data:params
        }
        await AxiosInstance.get(`${url}`,options).then((res) => {
            if (res && res.data) {

                setCards(res.data)
                let varFindPrimaryCard = findPrimaryCard(res.data)
                setPrimaryCard(varFindPrimaryCard)

            }
            setIsReady(true)
        }).catch((err) => {
            console.log(err)
            setIsReady(true)
        })
    }



    /**
     *
     * @param key
     * @param value
     */
    const onChangeStateView = (key: KeysViewSectionT, value) => {
        setStateViewSection((draft) => {
            draft[key] = value
        })
    }


    /**
     *
     * @param paymentMethodId
     * @returns
     */
    const completeSaveCard = async (paymentMethodId): Promise<string> => {
        let params = {
            paymentMethodId: paymentMethodId,
        }
        if (props.userId) {
            params['userId'] = props.userId
        }
        return await AxiosInstance.post(`${config.url.cards}/stripe`, params).then((res) => {
            if (res && res.data) {

                setTimeout(() => {
                    getCards()
                }, 1);

                setTimeout(() => {
                    onChangeStateView("showFormAddCard", false)
                    // setShowFormAddCard(false)
                    onChangeStateView("showListCard", false)
                    // setShowListCard(false)
                }, 1000);
                return "Card saved."
            }
        })
    }



    /**
     *
     */
    const getTotal = React.useCallback((items) => {
        let totalAmount = items.reduce((amount, item, index) => {
            return Number(amount) + Number(item.amount)
        }, 0)

        return totalAmount
    }, [props.paymentItems, lineItemTip])


    /**
 *
 */
    const rest = () => {
        setLineItemTip(null)
        setStateViewSection((draft) => {
            draft.showFormAddCard = false
            draft.showFormTip = false
            draft.showListCard = false
            draft.showConfirmButton = false
        })
    }

    /**
     *
     */
    const removeTip = () => {
        setLineItemTip(null)
        if (props.removeLineItemTip) {
            props.removeLineItemTip()
        }
    }


    /**
     * onChangeTip
     * @param amount
     */
    const onChangeTip = (amount) => {
        if (amount != 0) {
            const lineItem = {
                productItemId: randomId(12),
                productItem: "tip",
                productRate: amount,
                productUnits: 1,
                amount: Number(amount)
            }
            setLineItemTip(lineItem)
            if (props.addLineItemTip) {
                props.addLineItemTip(lineItem)
            }

        } else {
            removeTip()
        }
    }


    /**
     * renderFormTip
     * @returns
     */
    const renderFormTip = (): JSX.Element => {

        return (
            <FormTipPayment
                amount={getTotal(props.paymentItems)}
                onChange={onChangeTip}
                noTip={() => { removeTip() }}
                onChangeSelectOption={(selectedTip) => {
                    setOptionTip(selectedTip)
                }}
            />
        )
    }


    /**
     * renderListCard
     * @returns
     */
    const renderListCard = (): JSX.Element => {
        return (
            <>
                {(!isReady || !stripe) && [1, 2].map((item, index) => {
                    return (
                        <LineItemCard
                            isSkeleton={true}
                            isLoading={true}
                            key={index}
                            item={initObjectPaymentCard}

                            primaryCard={primaryCard}

                        />
                    )
                })}

                {!stateViewSection.showFormAddCard && <ListItemCards
                    stripe={stripe}
                    cards={cards}
                    primaryCard={primaryCard}
                    onChangePrimaryCard={(card) => {
                        setPrimaryCard(card)
                        onChangeStateView("showListCard", false)
                        // setShowListCard(false)
                    }}
                    onRefreshCards={() => {
                        getCards()
                    }}
                    back={() => {
                        onChangeStateView("showListCard", false)
                        // setShowListCard(false)
                    }}
                />}

                <Box className="ml-2 mr-2 ">
                    {renderButtonAddNewCard()}

                    {stateViewSection.showListCard && <Button className="mt-2" size="medium" variant="outlined" onClick={(e) => {
                        e.preventDefault()
                        if (stateViewSection.showFormAddCard) {
                            onChangeStateView("showFormAddCard", false)
                            // setShowFormAddCard(false)
                        } else {
                            onChangeStateView("showListCard", false)
                            // setShowListCard(false)
                        }

                    }}>  <ArrowBackIcon /> Back</Button>}
                </Box>
            </>
        )
    }




    /**
     * renderButtonAddNewCard
     * @returns
     */
    const renderButtonAddNewCard = (): JSX.Element => {
        return (
            <>
                {!stateViewSection.showFormAddCard && <Button
                    className="mt-2"
                    fullWidth
                    color="info"
                    variant="contained"
                    onClick={(e) => {
                        e.preventDefault()
                        onChangeStateView("showFormAddCard", true)
                    }} >Add New Card</Button>}

                {stateViewSection.showFormAddCard &&
                    <FormSaveCard publishableKey={config.stripePublishableKey}
                        completeSaveCard={completeSaveCard}
                        back={() => { onChangeStateView("showFormAddCard", false) }} />}

            </>

        )
    }

    /**
     * renderButtonAddPrimaryCard
     * @returns
     */
    const renderButtonAddPrimaryCard = (): JSX.Element => {
        return (
            <>
                <Button
                    className="mt-2 mb-2"
                    fullWidth
                    color="info"
                    variant="contained" onClick={(e) => {
                        e.preventDefault()
                        onChangeStateView("showListCard", true)
                    }} >Add Primary Card</Button>
            </>
        )
    }

    /**
     *
     * @returns
     */
    const renderTotal = () => {
        return (
            <Box>
                <Box style={{ float: "right" }}>
                    <Box display="flex" flexDirection="column" justifyContent="center" alignItems="flex-start" p={1}>

                        {(stateViewSection.showFormTip && lineItemTip && lineItemTip.amount > 0) && <Typography textAlign="left" variant="h4">Tip: ${lineItemTip ? parseFloatTotal(lineItemTip.amount) : "0.00"}&nbsp;</Typography>}
                        <Typography textAlign="left" variant="h6">Total: ${parseFloatTotal(getTotal(allPaymentItems))}</Typography>
                    </Box>
                </Box>
            </Box>
        )
    }



    let customButtonProps = {}

    if (props.customButtonProps) {
        customButtonProps = props.customButtonProps || {}
    }

    console.log("optionTIp", optionTip)
    return (
        <div className=" mt-2 p-2" >


            <LoadElementsStripe

                publishableKey={config.stripePublishableKey}
                onFinishedLoad={(stripe) => {
                    // console.log("stripe", stripe)
                    setStripe(stripe)
                }}
            >

                {stateViewSection.showListCard && renderListCard()}




                <Box display="flex" flexDirection="column">
                    {(isReady && stripe && !stateViewSection.showListCard && !stateViewSection.showFormAddCard) &&

                        <>
                            {(stateViewSection.showFormTip && primaryCard && !stateViewSection.showConfirmButton) && renderFormTip()}

                            {renderTotal()}
                        </>}
                    {(primaryCard && !stateViewSection.showListCard && !stateViewSection.showFormAddCard && !stateViewSection.showConfirmButton) &&
                        <Box display="flex" alignItems="center" justifyContent="flex-start" >

                            <Typography >Using card ending in {primaryCard && primaryCard.cardNumberMasked}.</Typography>
                            <Button onClick={(e) => {
                                e.preventDefault()
                                onChangeStateView("showListCard", true)
                                // setShowListCard(true)
                            }} >
                                Change Card?
                            </Button>
                        </Box>}
                    {(isReady && stripe && !stateViewSection.showListCard && !stateViewSection.showFormAddCard) &&

                        <>

                            {(isReady && !primaryCard && !stateViewSection.showListCard && !stateViewSection.showFormAddCard) && renderButtonAddPrimaryCard()}



                            {(props.displayFormTip && !stateViewSection.showFormTip) ?
                                <Button
                                    disabled={!primaryCard ? true : false}
                                    variant="contained"
                                    color={"success"}
                                    {...customButtonProps}
                                    onClick={(e) => {
                                        onChangeStateView("showFormTip", true)
                                    }}
                                >
                                    {props.titleButton ? `${props.titleButton}` : "Pay Now"}
                                </Button> :
                                <ButtonChargeCard
                                    userId={props.userId}
                                    item={primaryCard}
                                    stripe={stripe}
                                    productId={props.productId}
                                    productType={props.productType}
                                    paymentItems={allPaymentItems}
                                    titleButton={props.titleButton ? props.titleButton : "Pay Now"}
                                    customButtonProps={{ ...{ variant: "contained", color: "success", fullWidth: true, disabled: !primaryCard || (stateViewSection.showFormTip && (!lineItemTip && optionTip != "noTip")) ? true : null }, ...props.customButtonProps }}

                                    onDisplayConfirmUi={() => {
                                        // onChangeStateView("showConfirmButton", true)
                                    }}
                                    onCompleteProcessing={(transaction) => {

                                        props.onCompleteProcessing(transaction)
                                        setTimeout(() => {
                                            rest()
                                            getCards()
                                        }, 500);
                                    }}

                                    back={() => {
                                        rest()
                                        getCards()
                                    }}

                                />}
                        </>}



                </Box>

            </LoadElementsStripe>
        </div >
    );
}
export default PayByCard;
export { PayByCard };
